// extracted by mini-css-extract-plugin
export default {"not-found-page":"NotFoundPage_not-found-page__s4gdU"};